import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "frontend-components/lib/utils";

function Widget({ className, ...props }: React.ComponentProps<"section">) {
    return (
        <section
            data-slot="widget"
            className={cn(
                "group/widget bg-compendia-card border-compendia-border flex h-full min-h-0 min-w-0 flex-col overflow-hidden rounded-[3px] border",
                className,
            )}
            {...props}
        />
    );
}

function WidgetHeader({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="widget-header"
            className={cn(
                "border-compendia-border flex h-16 shrink-0 items-center gap-2 border-b px-5",
                className,
            )}
            {...props}
        />
    );
}

const widgetTitleVariants = cva("text-text-primary font-medium leading-snug", {
    variants: {
        size: {
            sm: "text-sm",
            base: "text-base",
            lg: "text-lg",
            xl: "text-xl",
        },
    },
    defaultVariants: {
        size: "lg",
    },
});

function WidgetTitle({
    className,
    size,
    ...props
}: React.ComponentProps<"h3"> & VariantProps<typeof widgetTitleVariants>) {
    return (
        <h3
            data-slot="widget-title"
            className={cn(widgetTitleVariants({ size, className }))}
            {...props}
        />
    );
}

function WidgetActions({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="widget-actions"
            className={cn("ml-auto flex items-center gap-2", className)}
            {...props}
        />
    );
}

function WidgetContent({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="widget-content"
            className={cn("flex min-h-0 flex-1 flex-col gap-6 px-5 py-4", className)}
            {...props}
        />
    );
}

export { Widget, WidgetHeader, WidgetTitle, WidgetActions, WidgetContent, widgetTitleVariants };
